import { NavLink, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { MENU_ROUTES } from '../../constants';
import { IconNavBuilder, IconNavDesignSystem, IconNavOverview } from '../../core';
import { textStyle } from '../../styles/mixins/_commonPageContentStyles';

interface Props {
  className?: string;
}

const HeaderNavigation = ({ className = '' }: Props) => {
  const { pathname } = useLocation();

  return (
    <div className={className}>
      <ul>
        <li>
          <NavLink to="/overview" className={({ isActive }) => (isActive ? 'active' : '')}>
            <IconNavOverview className="icon" />
            <span>Overview</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="/builder" className={({ isActive }) => (isActive ? 'active' : '')}>
            <IconNavBuilder className="icon" />
            <span>Builder</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive ||
              (pathname !== MENU_ROUTES.overview.path && pathname !== MENU_ROUTES.builder.path)
                ? 'active'
                : ''
            }
          >
            <IconNavDesignSystem className="icon" />
            <span>Design System</span>
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

const HeaderNavigationStyled = styled(HeaderNavigation)`
  ul {
    display: flex;
    gap: 0.5rem;
    padding-left: 0;
  }

  li {
    list-style: none;
  }

  a,
  button {
    border: 0 none;
    background: transparent none;
    display: flex;
    gap: 0.5rem;
    ${textStyle('h4Sb')}
    color: ${({ theme }) => theme.neutralTextWeak};
    cursor: pointer;
    height: 2.5rem;
    padding: 0 0.625rem;
    align-items: center;
    border-radius: 0.375rem;
    text-decoration: none;
    transition:
      color 0.3s ease-in-out,
      background 0.3s ease-in-out;
    position: relative;

    &:not(.active) {
      &:hover {
        color: ${({ theme }) => theme.neutralText};
        background-color: ${({ theme }) => theme.neutralBackgroundHover};

        .icon {
          color: ${({ theme }) => theme.neutralText};
        }
      }
    }
  }

  span {
  }

  .active {
    color: ${({ theme }) => theme.primaryText};
    background-color: ${({ theme }) => theme.neutralBackgroundBase};
    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: -16px;
      left: -2px;
      right: -2px;
      box-sizing: content-box;
      height: 2px;
      background: ${({ theme }) => theme.primaryBorder};
      border: 0 solid ${({ theme }) => theme.neutralBackgroundMedium};
      border-width: 0 2px 2px;
      border-bottom-left-radius: 1px;
      border-bottom-right-radius: 1px;
    }
  }

  .icon {
    transition: color 0.3s ease-in-out;
  }
`;

export default HeaderNavigationStyled;
